import { Omnichannel as o } from "./omnichannel.js";
import { RevenueAccelerate as r } from "./revenue-accelerate.js";
import { AdyenForPlatforms as m } from "./adyen-for-platforms.js";
import { AdyenForPlatformsAdvanced as t } from "./adyen-for-platforms-advanced.js";
import { AdyenForPlatformsLink as i } from "./adyen-for-platforms-link.js";
import { AdyenForPlatformsManage as e } from "./adyen-for-platforms-manage.js";
import { OilSplash as p } from "./oil-splash.js";
import { Network as f } from "./network.js";
import { Acquiring as a } from "./acquiring.js";
import { SchemeProducts as n } from "./scheme-products.js";
import { Gateway as l } from "./gateway.js";
import { Technology as u } from "./technology.js";
import { Recurring as c } from "./recurring.js";
import { Processing as s } from "./processing.js";
import { SmartRouting as h } from "./smart-routing.js";
import { Scalability as P } from "./scalability.js";
import { NoThirdParty as y } from "./no-third-party.js";
import { RevenueProtect as F } from "./revenue-protect.js";
import { RiskDanger as O } from "./risk-danger.js";
import { IdentityRisk as d } from "./identity-risk.js";
import { Knowledge as k } from "./knowledge.js";
import { Lock as A } from "./lock.js";
import { Security as g } from "./security.js";
import { Safe as S } from "./safe.js";
import { Checkout as C } from "./checkout.js";
import { CheckoutPayByLink as M } from "./checkout-pay-by-link.js";
import { CheckoutDropIn as L } from "./checkout-drop-in.js";
import { CheckoutComponents as R } from "./checkout-components.js";
import { CheckoutApiOnly as w } from "./checkout-api-only.js";
import { Platform as D } from "./platform.js";
import { PlatformGrowth as I } from "./platform-growth.js";
import { PlatformBusinessStructure as v } from "./platform-business-structure.js";
import { CoreDataStructure as x } from "./core-data-structure.js";
import { FinanceDataCore as B } from "./finance-data-core.js";
import { Partner as T } from "./partner.js";
import { LanguageLocalization as b } from "./language-localization.js";
import { MlPaymentOptimizationExperimentation as z } from "./ml-payment-optimization-experimentation.js";
import { PosMobile as E } from "./pos-mobile.js";
import { FormulaDifferentPeople as G } from "./formula-different-people.js";
import { FormulaGoodChoices as U } from "./formula-good-choices.js";
import { FormulaLaunchFast as N } from "./formula-launch-fast.js";
import { FormulaPickUpThePhone as W } from "./formula-pick-up-the-phone.js";
import { FormulaWinningIsMoreImportant as q } from "./formula-winning-is-more-important.js";
import { FormulaTalkStraight as K } from "./formula-talk-straight.js";
import { UnifiedCommerce as j } from "./unified-commerce.js";
import { FormulaCreateOwnPath as H } from "./formula-create-own-path.js";
import { Oauth as J } from "./oauth.js";
import { OauthScalability as Q } from "./oauth-scalability.js";
import { OauthAutomation as V } from "./oauth-automation.js";
import { OauthUserExperience as X } from "./oauth-user-experience.js";
import { OauthSecurity as Y } from "./oauth-security.js";
import { AppStore as Z } from "./app-store.js";
import { FormulaBenefitAllMerchants as _ } from "./formula-benefit-all-merchants.js";
import { Macos as $ } from "./macos.js";
import { MlPaymentOptimizationAndExperimentation as oo } from "./ml-payment-optimization-and-experimentation.js";
import { MystoreWave as ro } from "./mystore-wave.js";
import { Oilsplash as mo } from "./oilsplash.js";
import { OptIn as to } from "./opt-in.js";
import { OptOut as io } from "./opt-out.js";
import { FormulaBenifitAllMerchants as eo } from "./formula-benifit-all-merchants.js";
const sr = {
  Omnichannel: o,
  RevenueAccelerate: r,
  AdyenForPlatforms: m,
  AdyenForPlatformsAdvanced: t,
  AdyenForPlatformsLink: i,
  AdyenForPlatformsManage: e,
  OilSplash: p,
  Network: f,
  Acquiring: a,
  SchemeProducts: n,
  Gateway: l,
  Technology: u,
  Recurring: c,
  Processing: s,
  SmartRouting: h,
  Scalability: P,
  NoThirdParty: y,
  RevenueProtect: F,
  RiskDanger: O,
  IdentityRisk: d,
  Knowledge: k,
  Lock: A,
  Security: g,
  Safe: S,
  Checkout: C,
  CheckoutPayByLink: M,
  CheckoutDropIn: L,
  CheckoutComponents: R,
  CheckoutApiOnly: w,
  Platform: D,
  PlatformGrowth: I,
  PlatformBusinessStructure: v,
  CoreDataStructure: x,
  FinanceDataCore: B,
  Partner: T,
  LanguageLocalization: b,
  MlPaymentOptimizationExperimentation: z,
  PosMobile: E,
  FormulaDifferentPeople: G,
  FormulaGoodChoices: U,
  FormulaLaunchFast: N,
  FormulaPickUpThePhone: W,
  FormulaWinningIsMoreImportant: q,
  FormulaTalkStraight: K,
  UnifiedCommerce: j,
  FormulaCreateOwnPath: H,
  Oauth: J,
  OauthScalability: Q,
  OauthAutomation: V,
  OauthUserExperience: X,
  OauthSecurity: Y,
  AppStore: Z,
  FormulaBenefitAllMerchants: _,
  Macos: $,
  MlPaymentOptimizationAndExperimentation: oo,
  MystoreWave: ro,
  Oilsplash: mo,
  OptIn: to,
  OptOut: io,
  FormulaBenifitAllMerchants: eo
};
export {
  sr as Products
};
